
<div class="spacer-bottom" *ngIf="contacMode">
	<div class="ac-color animated {{options.stepDirectionClass}}" style="padding:3px 16px 16px;">
		<div class="my-panel mb-base no-shadow text-base condensed-fields" *ngIf="contacMode">
			<div class="my-panel-body">
				<div class="_panel-title"><div>{{'whoIsPaying' | translate}}</div></div>
				<form #f="ngForm" [formGroup]="contactForm" class="condensed-fields">
					<div class="row small-gutters">
						<div class="col-12">
							<mat-form-field color="accent" appearance="outline">
								<mat-label>{{'name' | translate}}</mat-label>
								<input #name name="name" matInput formControlName="name" required>
							</mat-form-field>
						</div>
						<div class="col-12">
							<mat-form-field color="accent" appearance="outline" class="with-pad">
								<mat-label>{{'mobile' | translate}}</mat-label>
								<oao-mat-intl-tel-input [preferredCountries]="appService.regionArgs.phonePreferredCountries"
														[onlyCountries]="appService.regionArgs.phoneOnlyCountries"
														[enablePlaceholder]="true"
														[enableSearch]="true"
														[searchPlaceholder]="appService.translate('search')"
														format="national"
														required
														name="phone"
														formControlName="phone"
														#phone></oao-mat-intl-tel-input>
								<!--<mat-hint>e.g. {{phone.selectedCountry.placeHolder}}</mat-hint>-->
								<!--<mat-error *ngIf="f.form.controls['phone']?.errors?.required">Required Field</mat-error>-->
								<mat-error *ngIf="f.form.controls['phone']?.errors?.validatePhoneNumber">{{'invalid_phone' | translate}}</mat-error>
							</mat-form-field>
						</div>
					</div>

				</form>

				<div class="mt-2">
					<button mat-raised-button color="accent" class="lg main-continue-btn" type="submit" (click)="applyContact($event)" *ngIf="contacMode">
						<div class="_inner">
							<span>{{'continue' | translate}}</span>
							<div class="_cont rotate-rtl"><mat-icon svgIcon="arrow_next"></mat-icon></div>
						</div>
					</button>
				</div>


			</div>
		</div>
	</div>

</div>


<form #paymentForm="ngForm" class="spacer-bottom" *ngIf="!contacMode">
	<div class="ac-color animated {{options.stepDirectionClass}}" style="padding:10px 16px 16px;">

		<!--<app-signup-banner _class="mb-1" [position]="'pay'"></app-signup-banner>-->

		<div class="condensed-fields">
			<!--START PAYMENT SELECTION-->
			<div class="my-panel-title"><div>{{(showPaymentTypes ? 'PAY_WITH' : 'additional_details') | translate}}</div></div>
			<ng-container>
				<div class="saved-payments-container" [class._half-width]="ui.paymentMethods.length > 3">
					<!--start saved payments-->
					@if (walletPm) {
						<div class="wallet-payment-container" [class.active]="$storage.wallet?.ccinfo == walletPm">
							<div class="_pm" *ngFor="let pm of $storage.wallet.pms; let last = last" (click)="setWalletPayment(pm)" [class._last]="last" [class._active]="pm == walletPm">
								<mat-icon svgIcon="credit_card"></mat-icon>
								<span>
										<span class="inline">{{ pm.paymentType == 'adyen' ? pm.issuer : ('PMS.' + pm.paymentType | translate) }}</span>
									{{pm.displayPan}}
									</span>
								<strong class="text-xs ml-2" *ngIf="['creditCard', 'creditGuard'].includes(pm.paymentType)" [ngClass]="{'text-danger':pm.expired }">
									{{pm | paymentExp}}
								</strong>
								<i class="text-xs text-truncate ml-2">{{pm.comment}}</i>
							</div>
						</div>
						<div class="or-separator"><span>{{'OR' | translate}}</span></div>
					}

					<!--end saved payments-->
					<!--start google/apple payments-->
					<div *ngIf="expayService.showNativePaymentButtons($storage)" class="_native-payments-container">
						<div class="apple-pay-button-wrapper"></div>
						<div class="google-pay-button-wrapper" (click)="initGooglePaymentRequest()"></div>
					</div>
					<!--end google/apple payments-->
					<!--start generic payments-->
					<button type="button" color="accent" class="pm-button-stroked _pm" style="justify-content:start" *ngFor="let pm of ui.paymentMethods" [class.active]="ccinfo.account == pm._id" (click)="setPaymentMethod(ccinfo, pm)">
						<!--<mat-icon svgIcon="credit_card" class="mr-2"></mat-icon>-->
						<div class="_pmlogo mr-2" [ngStyle]="{'background-image': 'url(' + (pm.paymentType | pmimage) + ')'}"></div>
						<div style="text-align:start; line-height: 18px;">{{pm.name | translate}}</div>
					</button>
					<!--end generic payments-->
				</div>
			</ng-container>
			<!--END PAYMENT SELECTION-->
			<!--START PM ADDITIONAL DETAILS-->

			<ng-container *ngIf="ccinfo.account && showPaymentTypes">
				<hr *ngIf="!appService.user" />

				<div [ngSwitch]="ccinfo.paymentMethod" *ngIf="ccinfo.paymentMethod" style="margin-bottom: 15px;">
					<div *ngSwitchCase="'giftCard'">

						<div class="row small-gutters">
							<div class="col-12">
								<mat-form-field appearance="outline" *ngIf="$storage.giftCards.hasMultipleAccounts">
									<mat-label>{{'_GIFTCARD.select_card' | translate}}</mat-label>
									<mat-select [(ngModel)]="ccinfo.account" (selectionChange)="checkGiftCardAccount(ccinfo);" name="gCardAccount" requiered>
										<mat-option *ngFor="let acc of $storage.giftCards.accounts" [value]="acc._id">
											{{acc.name}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-12">
								<mat-form-field appearance="outline">
									<mat-label>{{'_GIFTCARD.number' | translate}}</mat-label>
									<input [(ngModel)]="ccinfo.number" name="gnumber" id="gNumber" matInput type="tel" required pattern="[0-9]*">
									<mat-icon matSuffix (click)="ccinfo.number = null" *ngIf="ccinfo.number">close</mat-icon>
								</mat-form-field>
							</div>
							<div class="col-12">
								<mat-form-field appearance="outline">
									<mat-label>{{'_GIFTCARD.cvv' | translate}}</mat-label>
									<input [(ngModel)]="ccinfo.cvv" name="cvv" matInput placeholder="{{'_GIFTCARD.cvv' | translate}}" type="tel"
										   pattern="[0-9]*" class="text-center">
									<mat-icon matSuffix (click)="ccinfo.cvv = null" *ngIf="ccinfo.cvv">close</mat-icon>
								</mat-form-field>
							</div>
						</div>
					</div>

					<div *ngSwitchCase="'creditCard'">
						<div class="row small-gutters">
							<div class="col-12">
								<mat-form-field appearance="outline">
									<mat-label>{{'credit_card_number' | translate}}</mat-label>
									<input [(ngModel)]="ccinfo.pan" name="cardnumber" id="cardNumber" matInput type="tel" required pattern="[0-9]*"
										   validCreditCard [ccInfo]="ccinfo" #cc="ngModel">
									<mat-icon matSuffix (click)="ccinfo.pan = null" *ngIf="ccinfo.pan" class="mr-2">close</mat-icon>
									<mat-icon matSuffix [svgIcon]="ccinfo && ccinfo.brand || 'cc'" matSuffix (click)="ccinfo.pan = null"></mat-icon>
									<!--<mat-error *ngIf="cc.dirty && cc.errors?.creditCard">{{cc.errors.creditCard | translate}}</mat-error>-->
								</mat-form-field>
							</div>
							<div class="col-5">
								<mat-form-field appearance="outline">
									<mat-label>{{'expiration' | translate}}</mat-label>
									<input [(ngModel)]="ccinfo.expiration" name="newexp" matInput placeholder="mm-yy" type="tel"
										   required validCardExpiration ccinfo="ccinfo" autocomplete="cc-exp" class="ltr-field text-center" [ccInfo]="ccinfo" #newexp="ngModel">
									<mat-icon matSuffix (click)="ccinfo.expiration = null" *ngIf="ccinfo.expiration">close</mat-icon>
								</mat-form-field>
							</div>
							<div class="col-7">
								<mat-form-field appearance="outline">
									<mat-label>{{'cvv' | translate}}</mat-label>
									<input [(ngModel)]="ccinfo.cvv" name="cvv" matInput placeholder="{{'CVV'}}" type="tel" required
										   pattern="[0-9]*" class="text-center" maxlength="4">
									<mat-icon matSuffix (click)="ccinfo.cvv = null" *ngIf="ccinfo.cvv">close</mat-icon>
								</mat-form-field>
							</div>
							<div class="col-12">
								<mat-form-field appearance="outline" *ngIf="ccinfo.requireIdPhoneTrans">
									<mat-label>{{'ID_CARD' | translate}}</mat-label>
									<input [(ngModel)]="ccinfo.idCard" name="idCard" matInput type="tel" required pattern="[0-9]*"
										   validIdCard #idCard="ngModel">
									<mat-icon matSuffix (click)="ccinfo.idCard = null" *ngIf="ccinfo.idCard">close</mat-icon>
									<!--<mat-error *ngIf="idCard.dirty && idCard.errors?.creditCard">{{idCard.errors.creditCard | translate}}</mat-error>-->
								</mat-form-field>
							</div>
						</div>


					</div>
					<div *ngSwitchCase="'Cibus'">
						<mat-form-field appearance="outline">
							<mat-label>{{'credit_card_number' | translate}}</mat-label>
							<input [(ngModel)]="ccinfo.pan" name="cardnumber" id="cardNumber" matInput type="tel" required pattern="[0-9]*">
							<mat-icon matSuffix (click)="ccinfo.pan = null" *ngIf="ccinfo.pan">close</mat-icon>
						</mat-form-field>
					</div>
					<div *ngSwitchCase="'10bis'">
						<mat-form-field appearance="outline">
							<mat-label>{{'credit_card_number' | translate}}</mat-label>
							<input [(ngModel)]="ccinfo.pan" name="cardnumber" id="cardNumber" matInput type="tel" required
								   pattern="[0-9]*">
							<mat-icon matSuffix (click)="ccinfo.pan = null" *ngIf="ccinfo.pan">close</mat-icon>
						</mat-form-field>
					</div>
					<div *ngSwitchCase="'TavHazahav'">
						<mat-form-field appearance="outline">
							<mat-label>{{'credit_card_number' | translate}}</mat-label>
							<input [(ngModel)]="ccinfo.pan" name="cardnumber" id="cardNumber" matInput type="tel" required
								   pattern="[0-9]*">
							<mat-icon matSuffix (click)="ccinfo.pan = null" *ngIf="ccinfo.pan">close</mat-icon>
						</mat-form-field>
					</div>
				</div>
				<!--END PM ADDITIONAL DETAILS-->
				<!--START PM SECURITY DETAILS-->
				<ng-container *ngIf="!['Stripe', 'AuthorizeNet'].includes(ccinfo.paymentMethod) && ccinfo.paymentVerificationStrategy && ccinfo.paymentVerificationStrategy != 'none'">
					<div class="text-md font-bold mb-3 mt-3">{{'billing_address' | translate}}</div>
					<ng-container *ngIf="ccinfo.paymentVerificationStrategy == 'fullAddress'">
						<div class="row small-gutters">
							<div class="col-12">
								<mat-form-field appearance="outline">
									<mat-label>{{'address' | translate}}</mat-label>
									<input [(ngModel)]="ccinfo.address" name="address" matInput placeholder="{{'address' | translate}}" required>
									<mat-icon matSuffix (click)="ccinfo.address = null" *ngIf="ccinfo.address">close</mat-icon>
								</mat-form-field>
							</div>
							<div class="col-12">
								<mat-form-field appearance="outline">
									<mat-label>{{'city' | translate}}</mat-label>
									<input [(ngModel)]="ccinfo.city" name="city" matInput placeholder="{{'city' | translate}}" required>
									<mat-icon matSuffix (click)="ccinfo.city = null" *ngIf="ccinfo.city">close</mat-icon>
								</mat-form-field>
							</div>
							<div class="col-12">
								<mat-form-field appearance="outline">
									<mat-label>{{'state' | translate}}*</mat-label>
									<mat-select [(ngModel)]="ccinfo.state" name="usState" requiered [formControl]="stateFormControl">
										<mat-option *ngFor="let state of usStates" [value]="state.v">
											{{state.t}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
						</div>
					</ng-container>
					<mat-form-field appearance="outline">
						<mat-label>{{'zip' | translate}}</mat-label>
						<input [(ngModel)]="ccinfo.zip" name="zip" matInput type="text" required maxlength="10" validZip>
						<mat-icon matSuffix (click)="ccinfo.zip = null" *ngIf="ccinfo.number">close</mat-icon>
					</mat-form-field>
					<hr />
				</ng-container>
				<!--END PM SECURITY DETAILS-->

				<ng-container *ngIf="appService.user && enableSaveToWallet">
					<mat-form-field appearance="outline">
						<mat-label>{{'comments' | translate}}</mat-label>
						<input [(ngModel)]="ccinfo.comment" name="comment" matInput>
					</mat-form-field>
				</ng-container>

				<ng-container *ngIf="!appService.user">
					<ng-container *ngIf="ccinfo.paymentMethod != 'Meshulam'">

						<div class="row small-gutters">
							<div class="col-12">
								<mat-form-field color="accent" appearance="outline">
									<mat-label>{{'card_holder_name' | translate}}</mat-label>
									<input [(ngModel)]="$storage.contact.firstName" name="firstName" matInput required>
									<mat-icon matSuffix (click)="$storage.contact.firstName = null" *ngIf="$storage.contact.firstName">close</mat-icon>
								</mat-form-field>
							</div>
							<div class="col-12">
								<form #f="ngForm" [formGroup]="phoneForm" class="condensed-fields">
									<mat-form-field color="accent" appearance="outline" class="with-pad">
										<mat-label>{{'mobile' | translate}}</mat-label>
										<oao-mat-intl-tel-input [preferredCountries]="appService.regionArgs.phonePreferredCountries"
																[onlyCountries]="appService.regionArgs.phoneOnlyCountries"
																[enablePlaceholder]="true"
																[enableSearch]="true"
																[searchPlaceholder]="appService.translate('search')"
																required
																format="national"
																name="phone"
																formControlName="phone"
																#phone></oao-mat-intl-tel-input>
										<!--<mat-hint>e.g. {{phone.selectedCountry.placeHolder}}</mat-hint>-->
										<!--<mat-error *ngIf="f.form.controls['phone']?.errors?.required">Required Field</mat-error>-->
										<mat-error *ngIf="f.form.controls['phone']?.errors?.validatePhoneNumber">{{'invalid_phone' | translate}}</mat-error>
									</mat-form-field>
								</form>
							</div>
						</div>
					</ng-container>

					<div class="text-md">
						<mat-checkbox class="text-md" name="updatePaymentInfo" [(ngModel)]="$storage.contact.contractApprove">
							{{'READ_AND_APPROVE_CONTRACT' | translate}}
						</mat-checkbox>
						<div class="text-base" style="display:inline-flex; gap:5px; margin-inline-start: 50px; position:relative; top:-10px;">
							<a class="inline link" (click)="appService.showContractDialog('contract')">
								{{'READ_AND_APPROVE_CONTRACT_C' | translate}}
							</a>
							<div>,</div>
							<a class="inline link" (click)="appService.showContractDialog('privacy')">
								{{'READ_AND_APPROVE_CONTRACT_D' | translate}}
							</a>
						</div>
					</div>
				</ng-container>
				<div class="" *ngIf="enableSaveToWallet && appService.user && !ccinfo.$$isExternal && ccinfo.paymentMethod && !$storage.rosConfig?.payments?.walletDisabled">
					<mat-checkbox class="example-margin" name="updatePaymentInfo" [(ngModel)]="ui.updatePaymentInfo">
						{{'SAVE_ACCOUNT_PAYMENT_INFO' | translate}}
					</mat-checkbox>
				</div>

			</ng-container>
		</div>
		<div class="grecaptcha-text ltr">
			<div>This site is protected by reCAPTCHA and the Google</div>
			<a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
			<a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.
		</div>
	</div>

    <!--START BOTTOM ACTION-->
	<div class="ac-color p-3 pb-4 fixed-bottom fix-pos-botton">
		<button mat-raised-button color="accent" class="lg main-continue-btn" type="submit" (click)="submit(paymentForm, $event)">
			<div class="_inner">
				<span>{{'PAY' | translate}}</span>
				<b>{{cache.grandTotalPlusTip | lcurrency}}</b>
				<div class="_cont rotate-rtl"><mat-icon svgIcon="arrow_next"></mat-icon></div>
			</div>
		</button>

	</div>
    <!--END BOTTOM ACTION-->

</form>



